var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopic3Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5319 15.6556C18.7394 15.8631 18.7394 16.1994 18.5319 16.4069L15.3444 19.5944C15.2448 19.694 15.1096 19.75 14.9688 19.75C14.8279 19.75 14.6927 19.694 14.5931 19.5944L12.9993 18.0007C12.7919 17.7932 12.7919 17.4568 12.9993 17.2493C13.2068 17.0419 13.5432 17.0419 13.7507 17.2493L14.9688 18.4674L17.7806 15.6556C17.9881 15.4481 18.3244 15.4481 18.5319 15.6556Z",
    fill: "#2071F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 7C11.0122 7 11.25 7.23785 11.25 7.53125V8.0625H19.75V7.53125C19.75 7.23785 19.9878 7 20.2812 7C20.5747 7 20.8125 7.23785 20.8125 7.53125V8.0625H21.875C23.0486 8.0625 24 9.01389 24 10.1875V21.875C24 23.0486 23.0486 24 21.875 24H9.125C7.9514 24 7 23.0486 7 21.875V10.1875C7 9.0139 7.95139 8.0625 9.125 8.0625H10.1875V7.53125C10.1875 7.23785 10.4253 7 10.7188 7ZM9.125 9.125C8.5382 9.125 8.0625 9.6007 8.0625 10.1875V21.875C8.0625 22.4618 8.5382 22.9375 9.125 22.9375H21.875C22.4618 22.9375 22.9375 22.4618 22.9375 21.875V10.1875C22.9375 9.6007 22.4618 9.125 21.875 9.125H9.125Z",
    fill: "#2071F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 11.25C9.65625 10.9566 9.8941 10.7188 10.1875 10.7188H20.8125C21.1059 10.7188 21.3438 10.9566 21.3438 11.25V12.3125C21.3438 12.6059 21.1059 12.8438 20.8125 12.8438H10.1875C9.8941 12.8438 9.65625 12.6059 9.65625 12.3125V11.25Z",
    fill: "#2071F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic3Active);
export default __webpack_public_path__ + "static/media/topic3_active.b0f402773419925884322c743a25a692.svg";
export { ForwardRef as ReactComponent };